<template>
  <div
    id="divContainer"
    v-on:click="exitmenu"
    class="page-effect remove-space"
    :style="
      'background-color: #f1f3f4; overflow:hidden; position: relative; ' +
      getHeight()
    "
  >
    <div class="dynamic-chat-button" v-if="IsChatEnabled == true && ChatRoomID">
      <v-btn
        class=""
        fab
        dark
        color="#fb8d03"
        @click="openGroupChat(ChatRoomID)"
      >
        <img
          src="../assets/Images/chat-assets/tawk.svg"
          height="40px"
          width="40px"
        />
      </v-btn>
      <p>Chat Now</p>
    </div>

    <!-- <TopMenu /> -->
    <section v-if="pageHTML" id="sectionId" class="d-flex flex-column" style="width: 100%; height: 100%;">
      <div v-html="pageHTML" style="position: relative; width: 100%"></div>
      <div class="rest-mobile-potrait-section" style="height: calc(100% - 24.03%); background: #2f2b2c;">
        <div class="dynamicpage-rotation-image">
          <img src="../assets/Images/rotate.svg" />
          <h5>Please Rotate Your Device To Landscape</h5>
        </div>
      </div>
    </section>
    <section
      v-else
      id="sectionId"
      class="d-flex"
      style="
        justify-content: center;
        align-items: center;
        height: 100%;
        position: relative;
      "
    >
      <center v-show="!loading">
        <h2 style="color: #000">We didn't find anything to show here!</h2>
        <h4><a href="/lobby">Go back to Lobby</a></h4>
      </center>
    </section>

    <v-dialog
      v-if="showRequestMeetingInExpoHall"
      ref="exMeeting"
      v-model="dialog"
      content-class="client-dialog-exhibitors rounded-lg"
      transition="scroll-x-reverse-transition"
      width="auto"
    >
      <v-card>
        <!-- <v-toolbar
          class="pl-8"
          color="primary"
          style="box-shadow: none; background-color: #fff !important"
        >
          <v-toolbar-title
            class="text-h5 ml-2 mt-6"
            style="color: #000; font-weight: 500"
          >
         
          </v-toolbar-title>
          <v-spacer></v-spacer> -->
        <!--<v-toolbar-items style="height: 40px"> </v-toolbar-items>-->

        <!-- </v-toolbar> -->
        <!--<v-card-title>
          <div style="position: absolute; right: 10px; top: 10px">
            Book Appointment
          </div>
        </v-card-title>-->
        <v-card-text
          id="ClientLobbyCard"
          class="ex-dialog-body"
          style="p-0;font-size:1rem; margin-top:0"
          rounded-lg
        >
          <div style="position: absolute; right: 0px; top: 0px">
            <v-icon style="z-index: 2" size="32" @click="closeHandler()"
              >close</v-icon
            >
          </div>
          <div class="apointment-pop-hld" style="width: 100%">
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="black"></v-tabs-slider>
              <v-tab
                v-if="allowRequestMeeting"
                id="tabExhibitorsSchedule"
                href="#schedule"
                style="margin-left: 0"
                @click="openSchedulePopup('/mymeetings')"
                class="tab-top first-tab"
                >Book Appointment
              </v-tab>
              <v-tab
                href="#meeting"
                @click="openSchedulePopup('/mymeetings')"
                style="margin-left: 0"
                class="tab-top"
                >Confirmed Meetings
              </v-tab>
              <v-tab-item
                v-if="allowRequestMeeting"
                value="schedule"
                class="tab-content"
              >
                <Exhibitors
                  :Exhibitorlist="Exhibitorlist"
                  @OpenRequestMeeting="OpenRequestMeeting($event)"
                ></Exhibitors>
              </v-tab-item>
              <v-tab-item value="meeting" class="tab-content">
                <ExhibitorsMeeting
                  :uid="uid"
                  :allowRequestMeeting="allowRequestMeeting"
                  @goToBookAppointment="goToBookAppointment"
                ></ExhibitorsMeeting>
                <!--<router-view></router-view>-->
                <!--<v-card flat>
									<v-card-text v-text="text"></v-card-text>
								</v-card>-->
              </v-tab-item>
            </v-tabs>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <RequestMeeting
      v-if="currentAttendee"
      :key="requestMeetingKey"
      :attendee="currentAttendee"
    ></RequestMeeting>
  </div>
</template>
<script>
import Vue from "vue";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import store from "../store";
import Exhibitors from "@/components/Exhibitors.vue";
import ExhibitorsMeeting from "@/components/ExhibitorsMeeting.vue";
import RequestMeeting from "@/components/RequestMeeting.vue";
import { bus } from "@/main";
import axios from "axios";
import APIs from "@/components/APIInit";
import common from "@/common";

var dynamicLinksTimer;
let vm;
export default {
  components: {
    Exhibitors,
    ExhibitorsMeeting,
    RequestMeeting,
  },
  data() {
    return {
      uid: "",
      event_collectionName: "",
      pageUrl: "",
      dynamicMenuId: 0,
      pageHTML: "",
      loading: true,
      dialog: false,
      tab: "schedule",
      showRequestMeetingInExpoHall: false,
      Exhibitorlist: [],
      orderBy: "",
      imgURL:
        "https://resources.e2m.live/e2monair.appspot.com/temp%2FHB-coffee-bar.jpg?alt=media",
      IsChatEnabled: false,
      ChatRoomID: "",
      requestMeetingKey: 0,
      currentAttendee: null,
      allowRequestMeeting: true,
      allowDynamicLinkSwitch: false,
      dynamicLinks: [],
    };
  },
  watch: {
    allowDynamicLinkSwitch(val) {
      if (val) {
        //alert("allowDynamicLinkSwitch: " + val);
        dynamicLinksTimer = setInterval(function () {
          if (vm.dynamicLinks.length > 0) {
            //alert("allowDynamicLinkSwitch");
            var flag = false;
            var currentTime = parseInt(new Date().getTime() / 1000);
            vm.dynamicLinks.forEach(function (item) {
              //alert("#" + item.LinkId + "#");
              if (item.FromTime && item.ToTime && item.LinkId) {
                if (item.FromTime.seconds && item.ToTime.seconds) {
                  if (
                    currentTime >= item.FromTime.seconds &&
                    currentTime < item.ToTime.seconds
                  ) {
                    $("#" + item.LinkId).show();
                  } else {
                    $("#" + item.LinkId).hide();
                  }
                  if (currentTime < item.ToTime.seconds) {
                    flag = true;
                  }
                }
              }
            });
          }
          if (!flag) {
            if (dynamicLinksTimer) {
              clearInterval(dynamicLinksTimer);
            }
          }
        }, 1000);
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    next(true);
    let pageUrl = vm.$route.params.name;
    vm.renderPage(pageUrl);
  },
  beforeUpdate() {
    //alert("beforeUpdate");
  },
  updated() {
    $("#predefinedChat").click(function () {
      if (vm.ChatRoomID) {
        bus.$emit("openPredefinedChat", vm.ChatRoomID);
      }
    });
    vm.linkToRouterPush();
  },
  created() {
    vm = this;
    vm.uid = vm.getSessionUserId();
    vm.event_collectionName = vm.getEventCollectionName();
    let pageUrl = vm.$route.params.name;
    vm.renderPage(pageUrl);

    db.collection(vm.event_collectionName)
      .doc("AttendeeList")
      .collection("Attendees")
      .doc(vm.uid)
      .get()
      .then((attendeeDoc) => {
        if (attendeeDoc.exists) {
          var attendee = attendeeDoc.data();
          var registrationType = "";
          if (typeof attendee.RegistrationType == "string") {
            registrationType = attendee.RegistrationType;
          } else if (typeof attendee.RegistrationType == "object") {
            registrationType = attendee.RegistrationType.RegistrationType;
          }
          db.collection(vm.event_collectionName)
            .doc("AttendeeList")
            .collection("AttendeeSettings")
            .doc("FilterSettings")
            .get()
            .then((doc) => {
              if (doc.exists) {
                var data = doc.data();
                if (data.MeetingRestrictionEnabled) {
                  if (
                    data.AllowExMtngRqstForRegTypes &&
                    data.AllowExMtngRqstForRegTypes.length > 0 &&
                    !data.AllowExMtngRqstForRegTypes.includes(registrationType)
                  ) {
                    vm.allowRequestMeeting = false;
                  }
                  if (
                    vm.allowRequestMeeting &&
                    data.ExcludeGroupToRequestMeeting
                  ) {
                    vm.restrictedAttendeeIDs = [];
                    debugger;
                    let headers = {
                      "content-type": "application/json",
                      Authorization: "Bearer " + vm.getSessionToken(),
                    };
                    let requestData = {
                      key: {
                        instanceId: "OA_UAT",
                        clientId: vm.$store.state.client[0].id,
                        eventId: vm.$store.state.eventid,
                      },
                      data: {
                        groups: [
                          {
                            GroupId: data.ExcludeGroupToRequestMeeting,
                          },
                        ],
                      },
                    };
                    axios
                      .post(APIs.GetAttendees, requestData, {
                        headers: headers,
                      })
                      .then((responseData) => {
                        if (
                          responseData &&
                          responseData.data &&
                          responseData.data.status == 0 &&
                          responseData.data.groups
                        ) {
                          responseData.data.groups.forEach(function (group) {
                            if (group.attendees) {
                              group.attendees.forEach(function (item) {
                                if (item.AttendeeId == vm.uid) {
                                  vm.allowRequestMeeting = false;
                                }
                              });
                            }
                          });
                        } else {
                          console.log("Unable to fetch group attendees");
                        }
                      })
                      .catch((error) => {
                        //alert(error);
                        console.log(error);
                      });
                  }
                }
              }
            });
        }
      });
  },
  mounted() {
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#btnAddUserView").click();
    $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    //$("#topmenu").show();
    common.toggleTopMenu(true);
    common.toggleLeftMenu(true);
  },
  beforeDestroy() {
    if (dynamicLinksTimer) {
      clearInterval(dynamicLinksTimer);
    }
  },
  methods: {
    openGroupChat(roomId) {
      bus.$emit("openPredefinedChat", roomId);
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    getHeight() {
      return common.getHeaderHeight();
    },
    renderPage(pageUrl) {
      vm.loading = true;
      vm.pageHTML = "";
      if (!pageUrl) {
        pageUrl = "";
      }
      vm.pageUrl = pageUrl;
      db.collection(vm.event_collectionName)
        .doc("LandingPages")
        .get()
        .then((doc) => {
          if (doc.exists) {
            let data = doc.data();
            console.log(data);
            if (data.Pages) {
              data.Pages.forEach(function (item) {
                if (item.PageUrl == pageUrl) {
                  //alert("before");
                  vm.pageHTML = item.PageHTML;
                  //alert("vm.pageHTML:" + vm.pageHTML);
                  if (vm.pageHTML) {
                    vm.pageHTML = vm.getCDNUrl(vm.pageHTML);
                    vm.pageHTML = vm.pageHTML.replace(
                      /href/g,
                      "dynamic-html-link='true' href"
                    );
                    if (item.AllowDynamicLinkSwitch && item.DynamicLinks) {
                      vm.dynamicLinks = item.DynamicLinks;
                      var flag = false;
                      if (vm.dynamicLinks.length > 0) {
                        var currentTime = parseInt(new Date().getTime() / 1000);
                        vm.dynamicLinks.forEach(function (link) {
                          if (link.FromTime && link.ToTime && link.LinkId) {
                            if (link.FromTime.seconds && link.ToTime.seconds) {
                              if (currentTime < link.ToTime.seconds) {
                                flag = true;
                              }
                            }
                          }
                        });
                      }
                      if (flag) {
                        vm.allowDynamicLinkSwitch = item.AllowDynamicLinkSwitch;
                      }
                    }
                  }
                  if (item.MenuID) {
                    vm.dynamicMenuId = item.MenuID;
                  }
                  if (vm.dynamicMenuId == 1001003) {
                    vm.getSettings();
                  }
                  if (item.IsChatEnabled == true) {
                    bus.$emit("hideChatButton", false);
                    vm.IsChatEnabled = true;
                    vm.ChatRoomID = item.ChatRoomID;
                  } else if (item.ChatRoomID) {
                    vm.ChatRoomID = item.ChatRoomID;
                  } else {
                    bus.$emit("hideChatButton", true);
                    vm.IsChatEnabled = false;
                    vm.ChatRoomID = "";
                  }
                }
              });
            }
          }
          vm.loading = false;
        })
        .catch(function (error) {
          vm.loading = false;
          console.log(error);
        });
    },
    linkToRouterPush() {
      let allAtags = document.getElementsByTagName("a");
      allAtags.forEach((tag) => {
        let routeVal = tag.getAttribute("href");
        let dtl = tag.getAttribute("dynamic-html-link");
        if (dtl) {
          if (routeVal && routeVal.indexOf("/") >= 0) {
            tag.removeAttribute("href");
            tag.addEventListener("click", function (e) {
              console.log(e);
              //self.routerHandler(routeVal);
              if (routeVal.includes("http")) {
                window.open(routeVal);
              } else {
                //alert("push");
                vm.$router.push(routeVal);
              }
            });
          }
        }
      });
    },
    closeHandler() {
      vm.dialog = false;
    },
    openSchedulePopup(routeVal) {
      //routeVal = "/mymeetings";
      console.log(routeVal);
      //routeVal = "/livestage/1111_o2o";
      //if (!routeVal) {
      //  routeVal = "/mymeetings";
      //}
      if (routeVal) {
        //this.$router.replace("/exhibitorshall" + routeVal);
      }
      vm.dialog = true;
    },
    getSettings: function () {
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .doc("ExhibitorSettings")
        .get()
        .then((doc) => {
          if (doc.exists) {
            let data = doc.data();
            if (data.ShowRequestMeetingInExpoHall) {
              vm.showRequestMeetingInExpoHall =
                data.ShowRequestMeetingInExpoHall;

              let btnExAppointmentPopUp = document.getElementById(
                "btnExAppointmentPopUp"
              );
              btnExAppointmentPopUp.removeAttribute("style");
              if (btnExAppointmentPopUp) {
                btnExAppointmentPopUp.addEventListener("click", function (e) {
                  vm.openSchedulePopup();
                  e.stopPropagation();
                });
              }
              vm.getExhibitors();
            }
            if (data.OrderBy) {
              vm.orderBy = data.OrderBy;
            } else {
              vm.orderBy = "BoothNo";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getExhibitors: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      this.Exhibitorlist = [];
      var docRef;

      docRef = db
        .collection(obj.eventcollectionname)
        .doc("ExhibitorList")
        .collection("Exhibitors")
        .where("IsPublished", "==", true);

      docRef
        .get()
        .then((querySnapshot) => {
          var ctr = 0;
          querySnapshot.forEach((doc) => {
            let data = doc.data();

            vm.Exhibitorlist.push({
              sino: ctr++,
              id: doc.id,
              Name: data.Name,
              Logo: vm.getCDNUrl(data.Logo),
              Email: data.Email,
              Category: data.Category,
              Type: data.Type,
              BoothNo: data.BoothNo,
              HotspotImageUrL: vm.getCDNUrl(data.HotspotImageURL),
              Profile:
                doc
                  .data()
                  .Profile.replace(/<[^>]*>/g, "\n\r")
                  .substring(0, 300) + "...",
              Phone: data.Phone,
              Image: vm.getCDNUrl(data.Logo),
              MappedContacts: data.MappedContacts,
              contactcount: data.MappedContacts.length,
              Files: data.Resources,
              fileLength: data.Resources.length,
              ShowcaseVideoURL: data.ShowcaseVideoURL,
              isTooltipVisible: false,
              FullProfile:
                doc
                  .data()
                  .Profile.replace(/<[^>]*>/g, "\n\r")
                  .substring(0, 500) + "...",
            });
          });

          var exhibitorIds1 = "";
          vm.Exhibitorlist.map((expo) => {
            exhibitorIds1 += expo.id + ",";
          });
          if (exhibitorIds1 != "") {
            exhibitorIds1 = exhibitorIds1.substring(
              0,
              exhibitorIds1.length - 1
            );
          }

          store.commit("addExbList", exhibitorIds1);

          vm.Exhibitorlist = vm.Exhibitorlist.sort(function (a, b) {
            if (vm.orderBy == "BoothNo") {
              let v1 = a.BoothNo;
              let v2 = b.BoothNo;
              return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
            } else {
              let v1 = a.Name.toLowerCase().trim();
              let v2 = b.Name.toLowerCase().trim();
              return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goToBookAppointment() {
      //alert("D goToBookAppointment");
      //$("#tabExhibitorsSchedule").click();
      vm.tab = "schedule";
    },
    OpenRequestMeeting(data) {
      debugger;
      console.log("data=====", data);
      vm.requestMeetingKey++;
      vm.currentAttendee = data;

      //if (data.ProfilePictureURL != "") {
      //  var AttendeeImgPath = data.ProfilePictureURL;

      //  if (AttendeeImgPath != null && AttendeeImgPath != "") {
      //    document.getElementById("ReqAttendeeImage").src = AttendeeImgPath;
      //  }

      //  $("#ReqAttendeeImage").show();
      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerText = "";
      //    $("#ReqdivImgHldText").hide();
      //  }
      //} else {
      //  var Initials = "";
      //  if (document.getElementById("dvImgeHldText")) {
      //    Initials = document.getElementById("dvImgeHldText").innerText;
      //  }
      //  $("#ReqAttendeeImage").attr("src", "");
      //  $("#ReqAttendeeImage").hide();
      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerHTML =
      //      "<h4>" + Initials + "</h4>";
      //    $("#ReqdivImgHldText").show();
      //  }
      //}

      //if (document.getElementById("ReqAttendeeName")) {
      //  document.getElementById("ReqAttendeeName").innerText = data.Name;
      //}
      //if (document.getElementById("ReqAttendeeNameh4")) {
      //  document.getElementById("ReqAttendeeNameh4").innerText = data.Name;
      //}
      //if (document.getElementById("ReqAttendeeTitle")) {
      //  document.getElementById("ReqAttendeeTitle").innerText =
      //    data.Designation;
      //}
      //if (document.getElementById("ReqAttendeeCompany")) {
      //  document.getElementById("ReqAttendeeCompany").innerText = data.Company;
      //}
      //if (data.Email) {
      //  if (data.Email) {
      //    document.getElementById("ReqAttendeeEmail").href = data.Email;
      //    if (
      //      document.getElementById("ReqAttendeeEmail").href.indexOf("mailto") <
      //      0
      //    ) {
      //      $("#ReqAttendeeEmail").text(data.Email);
      //      document.getElementById("ReqAttendeeEmail").href =
      //        "mailto:" + document.getElementById("ReqAttendeeEmail").href;
      //    }
      //    $("#ReqAttendeeEmail").parent().show();
      //  } else {
      //    $("#ReqAttendeeEmail").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeeEmail").parent().hide();
      //}

      //if (data.Phone) {
      //  if (data.Phone) {
      //    document.getElementById("ReqAttendeePhone").href = data.Phone;
      //    if (
      //      document.getElementById("ReqAttendeePhone").href.indexOf("tel") < 0
      //    ) {
      //      $("#ReqAttendeePhone").text(data.Phone);
      //      document.getElementById("ReqAttendeePhone").href =
      //        "tel:" + document.getElementById("ReqAttendeePhone").href;
      //    }
      //    $("#ReqAttendeePhone").parent().show();
      //  } else {
      //    $("#ReqAttendeePhone").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeePhone").parent().hide();
      //}

      //$("#ReqAttendeeWebsite").parent().hide();
      $("#aFacebok").hide();
      $("#aTwitter").hide();
      $("#aLikedin").hide();
      $("#hdnAttendeeId").val(data.AttendeeId);
      var hdnattendeeId = data.AttendeeId;
      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: { attendeeId: hdnattendeeId },
      });
      instance.$mount();
      $("#myModal2").hide();
      $(".modal-backdrop").hide();
    },
  },
};
</script>


<style scoped>
.full-page-frame {
  height: calc(100vh - 116px) !important;
  width: 100%;
}
.pl-80 {
  padding-left: 80px;
}
</style>

<style>
.rest-mobile-potrait-section{display: none !important;}
.client-dialog-exhibitors {
  width: 1000px;
  /*min-height: 600px;
  max-height: 600px;*/
}
.client-dialog-exhibitors .v-sheet.v-card {
  border-radius: 0px !important;
}
.ex-dialog-body {
  /*margin: 20px !important;*/
  height: 530px;
}
.client-dialog-exhibitors .v-tab {
  text-transform: unset !important;
}
.client-dialog-exhibitors .tab-content {
  margin-top: 0px;
}
.client-dialog-exhibitors .tab-content .v-tab {
  margin-bottom: 10px;
}
.client-dialog-exhibitors .v-tab:first-child {
  margin-left: 0px !important;
}
.client-dialog-exhibitors .v-tab {
  padding: 6px !important;
}
.client-dialog-exhibitors .v-tabs.v-tabs--vertical .v-tab {
  padding: 0px !important;
  padding-right: 6px !important;
}
.client-dialog-exhibitors .v-tabs-bar {
  height: 60px !important;
}
.client-dialog-exhibitors .v-tabs.v-tabs--vertical .v-tabs-bar {
  height: unset !important;
}
#btnExAppointmentPopUp {
  color: #fff;
}
.dynamic-chat-button {
  position: fixed;
  z-index: 999;
  right: 3%;
  bottom: 7%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dynamic-chat-button p {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 !important;
  color: #fb8d03;
}
.tab-top {
  font-size: 22px !important;
}
.tab-top.first-tab {
  margin-left: 32px !important;
}

@media only screen and (max-width: 767px) {
  .tab-top {
    font-size: 16px !important;
  }
  .tab-top.first-tab {
    margin-left: 5px !important;
  }
  .client-dialog-exhibitors .v-tabs-bar {
    height: 80px !important;
  }
  .client-dialog-exhibitors .v-tabs-bar a.tab-top {
    width: 45%;
  }
}
@media only screen and (min-width: 100px) and (max-width: 490px){
  .rest-mobile-potrait-section{display: flex !important;}
}
</style>
